<template>
    <div class="handbook-version-select">
        <label class="sr-only" :for="id">{{ $t("handbook.version_select") }}</label>
        <select :value="currentVersion.slug" @change="changeVersion" :id="id">
            <option v-for="version in versions" :value="version.slug">{{ $t("handbook.version") }} {{ version.title }}</option>
        </select>
        <span aria-hidden="true">{{ $t("handbook.version") }} {{ currentVersion.title }}</span>
        <div>
            <ProIcon icon="select-arrow" />
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    computed: {
        ...mapGetters({
            currentVersion: "handbook/getCurrentVersion",
            versions: "handbook/getVersions",
        }),
    },
    props: {
        id: String,
    },
    methods: {
        changeVersion(e) {
            let pathSplit = this.$route.params.pathMatch.split("/");

            // Remove version first if it exists.
            if (/^\d+(\.?\d*)*$/g.test(pathSplit[0])) {
                pathSplit.shift();
                this.$router.push({ params: { pathMatch: e.target.value + "/" + pathSplit.join("/") } });
            } else {
                this.$router.push({ params: { pathMatch: e.target.value + "/" + this.$route.params.pathMatch } });
            }
        },
    },
};
</script>
